import React from 'react'
import { Button, Card, CardContent, Grid } from '@mui/material'
import { ArrowLeft, Plus } from 'react-feather'

import { LinearLoading } from 'common'
import { ExtraExpenseTable } from './ExtraExpenseTable'

export const ContractExtraExpenses = ({useFetchInit}) => {

    const {
        FetchData,
        Actions
    } = useFetchInit

    const {
        handleClickShowModalExpenses, // SE DEJA COMENTADO HASTA OBTENER CONFIRMACIÓN DE SI LOS GESTORES INGRESARAN GASTOS ADICIONALES O SOLO ADMIN
        handleClickCloseExpenses
    } = Actions

    const { fetchInfoExtraExpenses } = FetchData
    const { loadingFetchExtraExpenses } = fetchInfoExtraExpenses


    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card style={{zIndex:'1'}}>
                    <CardContent>
                        <Button
                            startIcon={<ArrowLeft/>}
                            variant='text'
                            color='error'
                            size='large'
                            sx={{ marginTop: 2, marginBottom : 2 }}
                            onClick={handleClickCloseExpenses}
                        >
                            Volver a la pantalla anterior
                        </Button>
                        <div className='h4 mt-1 mb-1'> Cargos Extras</div>
                        <div className="border-bottom border-dark"></div>
                        <div className="d-flex justify-content-end pt-4">
                            {/* SE DEJA COMENTADO HASTA OBTENER CONFIRMACIÓN DE SI LOS GESTORES INGRESARAN GASTOS ADICIONALES O SOLO ADMIN */}
                            {/* <Button
                                style={{ background: "#4b4b4c" }}
                                variant="contained"
                                type="button"
                                onClick={
                                    () => handleClickShowModalExpenses(
                                        '',
                                        'Formulario de cargos extras',
                                        'expenses-section',
                                        {}
                                    )
                                }
                                disabled={false}
                            >
                                <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                            </Button> */}
                        </div>

                        {loadingFetchExtraExpenses && ( <LinearLoading /> )}
                        {(!loadingFetchExtraExpenses) && (
                            <ExtraExpenseTable
                                useFetchInit={useFetchInit}
                            />
                        )}
                    </CardContent>
                </Card>
            </Grid> 
        </Grid>
    )
}
